window.addEventListener("scroll", () => {
    const navBar = document.getElementById("headerMain");
    const hamburgerCloseDesktop = document.getElementById("hamburgerMenu-close-desktop");
    let navBarHeight = navBar.getBoundingClientRect().height;

    if (document.documentElement.scrollTop && document.documentElement.scrollTop >= navBarHeight) {
        navBar.classList.add("is-scrolled");

        if (hamburgerCloseDesktop)
            hamburgerCloseDesktop.style.top = "4px";
    } else {
        if (navBar.classList.contains("is-scrolled")) {
            navBar.classList.remove("is-scrolled");

            if (hamburgerCloseDesktop)
                hamburgerCloseDesktop.style.top = "";
        }
    }
}, {
    passive: true
});
